import './abLoader.style.scss';
import {NAMES} from "@/scripts/components/ab-loader/constants/abLoader.constants";

export class AbLoaderElement extends HTMLElement {

  static get observedAttributes(): string[] {
    return [];
  }

  connectedCallback() {
    if (this.firstChild) return; // already mounted
    this.classList.add('ab-loader');
    this.innerHTML = `
        <div class="ab-loader__inner">
          <img class="ab-loader__image rotating-image" src="https://abcamera.it/wp-content/uploads/2023/09/cropped-favicon-150x150.png" />
          <p class="ab-loader__text">Caricamento...</p>
        </div>
      `;
  }

  disconnectedCallback() { }

  attributeChangedCallback() {
    if (!this.isConnected) return;
  }
}

export function defineAbLoaderElement() {

  const TAG_NAME = NAMES.TAG_NAME;
  if (customElements.get(TAG_NAME)) return;


  customElements.define(TAG_NAME, AbLoaderElement);
}
